import { render, staticRenderFns } from "./crear.rol.vue?vue&type=template&id=0188f526"
import script from "./crear.rol.vue?vue&type=script&lang=js"
export * from "./crear.rol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports